import React from 'react'

const styles = {
  urgent:  'bg-red-50 text-red-700 ring-red-200',
  soon:    'bg-yellow-50 text-yellow-700 ring-yellow-200',
  open:    'bg-green-50 text-green-700 ring-green-200',
  default: 'bg-gray-100 text-gray-600 ring-gray-200',
  indigo:  'bg-brand-100 text-brand-500 ring-indigo-200',
}

export default function Badge({ children, variant = 'default', className = '' }) {
  return (
    <span className={`
      inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset
      ${styles[variant] ?? styles.default} ${className}
    `}>
      {children}
    </span>
  )
}
